import React, { useEffect } from 'react'
import LogoutContent from './LogoutContent'
import withAuthSplit, { WithAuthSplitInjectedProps } from './withAuthSplit'

const bgImg = '../images/logoutImage.jpg'

interface LogoutProps extends WithAuthSplitInjectedProps {}

/**
 * Logout page — sets the split-screen background and renders LogoutContent.
 */
const Logout = ({ setBgProps }: LogoutProps) => {
    useEffect(() => setBgProps({ image: bgImg }), [setBgProps])

    return (
        <div className='text-center'>
            <LogoutContent layout='split' titleTag='h3' />
        </div>
    )
}

export default withAuthSplit(Logout)
